module.exports = __webpack_public_path__ + "static/media/whats-icon.96347ad3.svg";